import { InteractionStatus, InteractionType } from '@azure/msal-browser';
export var CacheLocation;
(function (CacheLocation) {
    CacheLocation["SessionStorage"] = "sessionStorage";
    CacheLocation["LocalStorage"] = "localStorage";
})(CacheLocation || (CacheLocation = {}));
// use this enum when using its value. use AuthInteractionStatus for its type
export const AuthInteractionStatusEnum = {
    ...InteractionStatus
};
// in the future, we can add additional auth type as needed to support new auth implementation
export var AuthImplementationEnum;
(function (AuthImplementationEnum) {
    AuthImplementationEnum["MSAL"] = "MSAL";
})(AuthImplementationEnum || (AuthImplementationEnum = {}));
// use this enum when using its value. use AuthInteractionType for its type
export const AuthInteractionEnum = {
    ...InteractionType
};
export var AuthErrorEnum;
(function (AuthErrorEnum) {
    AuthErrorEnum["LOGIN_ERROR"] = "login_error";
    AuthErrorEnum["LOGOUT_ERROR"] = "logout_error";
    AuthErrorEnum["ACQUIRE_TOKEN_ERROR"] = "acquire_token_error";
    AuthErrorEnum["OTHER_AUTH_ERROR"] = "other_auth_error";
})(AuthErrorEnum || (AuthErrorEnum = {}));
//# sourceMappingURL=types.js.map